import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { EditImageDialogEditformsComponent } from '../../../../edit-digital-forms/edit-image-dialog-editforms/edit-image-dialog-editforms.component';
import { SetupImplementService } from '../../../../setup-implement/setup-implement.service';
import { FileReaderEvent } from '../../../../../../shared/models/FileReader';
import { CrackObPointImagesVM } from '../../../equipment-details.model';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-view-obs-history-photo-dialog',
  templateUrl: './view-obs-history-photo-dialog.component.html',
  styleUrls: ['./view-obs-history-photo-dialog.component.scss'],

})
export class ViewObsHistoryPhotoDialogComponent implements OnInit {

  image: string;
  Id:number
  loadingPhoto: boolean = true;

 
  childId:number|null;

  constructor(private _dialogRef: MatDialogRef<ViewObsHistoryPhotoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,private _sanitizer: DomSanitizer,
    public _implementService: SetupImplementService, private _dialog: MatDialog,
    private _notify: NotificationsService,) { }

  ngOnInit() {
    this.image = this._data.image;
    this.Id = this._data.Id;
    console.log(this.image, this.Id)
    this.loadingPhoto=true;
  }

  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
}

onNoClick(): void {
  this._dialogRef.close();
}
EditedImage
  openEditImageComponent() {
    const dialogRef = this._dialog.open(EditImageDialogEditformsComponent, {
      data: {
        photoWithExt: 'data:image/*;base64,' + this.image,
        QuestionId: this.Id
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res != null) {
        this.image = res.photo;
         this.EditedImage =  this.image

         let params= new CrackObPointImagesVM()
         params.image=this.image
         params.Id=this.Id

this._implementService.EditCrackObservationPointImages(params).subscribe(res=>{
  if(res>0){
    this._notify.success("Image has been successfully Edited");
    
  }
})
        //new code
      
        
      }
    });
  }

deletePhoto()
{
  let params= new CrackObPointImagesVM()
  params.Id=this.Id
  

  this._implementService.deleteCrackObservationPointImages(params).subscribe(res=>{
    this._notify.success("Image has been successfully Deleted");
    this._dialogRef.close();

  })
}

onSelectPhoto(event: any) {
  if (event.target.files && event.target.files[0]) {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (event: any) => {
      const imageUrl = (event.target["result"]);
      //resize photo
      this.compressImage(imageUrl).then((res: string) => {
        // console.log("imageUrl", res)
        if (res) {
         //console.log('res', res)

          //photo.NewPhoto =  this.uploadPhoto(res.split(',')[1]);
          this.ReplacePhoto(res.split(',')[1]);
        }
      })
      //this.uploadPhoto(event.target.result.split(',')[1]);
    };
  }
}
private compressImage(src) {
  return new Promise((res, rej) => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      const elem = document.createElement('canvas');

      let width, height;
      width = img.width;
      height = img.height;

      console.log('width', width)
      console.log('height', height)

      var ratio = height / width; //cal aspect ratio
      let imageWidth = 800;//643
      var new_height = imageWidth * ratio; //calculate new height

      elem.width = imageWidth;
      elem.height = new_height;
      const ctx = elem.getContext('2d');
      ctx.drawImage(img, 0, 0, imageWidth, new_height);
      const data = ctx.canvas.toDataURL();
      res(data);
    }
    img.onerror = error => rej(error);
  })
}

ReplacePhoto(newPhoto: string){
  let params= new CrackObPointImagesVM()
  
    params.Id=this.Id    
    params.image=newPhoto
  
  this._implementService.EditCrackObservationPointImages(params).subscribe(res=>{
    this._notify.success("Image has been successfully Uploaded");
    this.image= newPhoto
  })
}


}
